import { render, staticRenderFns } from "./backheader.vue?vue&type=template&id=56090139"
import script from "./backheader.vue?vue&type=script&lang=js"
export * from "./backheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports